import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-down-thin",
  "use": "icon-chevron-down-thin-usage",
  "viewBox": "0 0 28 15.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 15.8\" id=\"icon-chevron-down-thin\"><title>chevron-down-thin</title><polygon id=\"icon-chevron-down-thin_Page-1\" points=\"28 1.5 26.6 0 14 12.9 14 12.9 14 12.9 1.4 0 0 1.5 12.6 14.4 14 15.8 14 15.8 14.8 15 28 1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/chevron-down-thin.svg
// module id = 270
// module chunks = 0 1